import React, { useState } from 'react';

import { Check, CopyIcon, ExternalLink, UnplugIcon } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import { NETWORK, useBtcWallet } from '@/networks/btc-like/btc';

const HeaderWalletDrawerBtcWalletDetailsActions: React.FC = () => {
  const [isCopied, setIsCopied] = useState(false);
  const { address, disconnect } = useBtcWallet();

  const handleCopyAddress = (e: React.MouseEvent) => {
    e.stopPropagation();
    void navigator.clipboard.writeText(address || '');
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 300);
  };

  return (
    <div className="flex gap-2">
      <Button variant="secondary" className="bg-foreground h-auto rounded-xl p-2 leading-2" onClick={handleCopyAddress}>
        {isCopied ? <Check className="size-4" color="green" /> : <CopyIcon className="size-4" />}
      </Button>

      <Button
        variant="secondary"
        className="bg-foreground h-auto rounded-xl p-2 leading-2"
        onClick={(e) => {
          e.stopPropagation();
          window.open(`${NETWORK.ExplorerUrl}/address/${address}`, '_blank', 'noopener,noreferrer');
        }}
      >
        <ExternalLink className="size-4" />
      </Button>

      <Button
        variant="secondary"
        className="bg-foreground h-auto rounded-xl p-2 leading-2"
        onClick={(e) => {
          e.stopPropagation();
          disconnect?.();
        }}
      >
        <UnplugIcon className="size-4" />
      </Button>
    </div>
  );
};

export default HeaderWalletDrawerBtcWalletDetailsActions;
